/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
// import { Application } from 'src/app/model/application';
// import { ApplicationProvider } from 'src/app/providers/application.provider';
import { Subject } from 'rxjs';
import { Report } from 'src/app/model';
import { SystemType } from 'src/app/model/enums/system.type';
import { ReportProvider } from 'src/app/providers';
import { ModeService,LogService } from 'src/app/services';

export enum PreviewSize{
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

@Component({
  selector: 'image-content',
  templateUrl: 'image-content.component.html',
  styleUrls: ['image-content.component.scss']
})

export class ImageContentComponent implements OnInit, OnDestroy {

  @ViewChild('preview', { read: ViewContainerRef }) previewElement: ElementRef;
  data: any;
  loading = false;
  report: Report;
  images: string[] = [];
  showRight = false;
  subject: Subject<boolean>;
  pin: boolean = false;
  timer: any = null;
  loadingDup: boolean = false;
  currentMode: SystemType;
  modeSub: any;
  PreviewSize = PreviewSize;
  size: PreviewSize = PreviewSize.SMALL;

  constructor(
    private reportProvider: ReportProvider,
    private modeService: ModeService,
    private logService : LogService
  ) { }


  ngOnInit(): void {
    if (this.images.length === 0 && this.isPdfFile() && this.hasPreview()){
      this.loadingDup = true;
      this.timer = setTimeout(() => {
        this.preview();
        this.loadingDup = false;
      }, 1000);
    }
    this.modeSub = this.modeService.mode$.subscribe(mode => this.currentMode = mode);
  }

  preview(): void {
    this.loading = true;
    if(this.report.DOCUMENT_ID){
      this.reportProvider.getDocuSignDocumentPreview(this.report.ID)
        .subscribe(data => {
          if (data.success){
            this.images = data.result;
          }
          this.loading = false;
        }, err => {
          this.logService.log(err);
          this.loading = false;
        });
    }else{
      this.reportProvider.getManualDocumentPreview(this.report.ID, this.currentMode)
        .subscribe(data => {
          if (data.success){
            this.images = data.result;
          }
          this.loading = false;
        }, err => {
          this.logService.log(err);
          this.loading = false;
        });
    }
  }

  isPdfFile(): boolean {
    return true;
  }

  hasPreview(): boolean {
    return true;
  }

  closePreview(): void{
    this.subject.next(true);
    this.subject.complete();
  }

  togglePin(event): void{
    this.pin = !this.pin;
  }

  ngOnDestroy(): void{
    clearTimeout(this.timer);
    if (this.modeSub) this.modeSub.unsubscribe();
  }

  expandArea(): void{
    if(this.size === PreviewSize.SMALL)
      this.size = PreviewSize.MEDIUM;
    else if(this.size === PreviewSize.MEDIUM)
      this.size = PreviewSize.LARGE;
    else
      this.size = PreviewSize.SMALL;
  }
}
